module.exports = __webpack_public_path__ + "img/icon_NOGAME.bdad9d82.png";